<template>
 <div class="dashboard-editor-container">
    <el-divider content-position="left">投诉总数 {{ stat.complaints.total }}</el-divider>
    <el-row class="panel-group" :gutter="40">
      <el-col :xs="12" :sm="12" :lg="8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <span
              class="icon iconfont icon-xiangmu"
              style="font-size: xxx-large"
            ></span>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">已提交</div>
            <span> {{ stat.complaints.submitted }}</span>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <span
              class="icon iconfont icon-xiangmu"
              style="font-size: xxx-large"
            ></span>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">调查中</div>
            <span> {{ stat.complaints.underInvestigation }}</span>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <span
              class="icon iconfont icon-xiangmu"
              style="font-size: xxx-large"
            ></span>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">已办结</div>
            <span> {{ stat.complaints.closed }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="panel-group" :gutter="40">
      <el-col :xs="12" :sm="12" :lg="8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <span
              class="icon iconfont icon-xiangmu"
              style="font-size: xxx-large"
            ></span>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">骚扰或辱骂</div>
            <span> {{ stat.complaints.abuse }}</span>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <span
              class="icon iconfont icon-xiangmu"
              style="font-size: xxx-large"
            ></span>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">不当内容</div>
            <span> {{ stat.complaints.illegal }}</span>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="8" class="card-panel-col">
        <div class="card-panel">
          <div class="card-panel-icon-wrapper icon-people">
            <span
              class="icon iconfont icon-xiangmu"
              style="font-size: xxx-large"
            ></span>
          </div>
          <div class="card-panel-description">
            <div class="card-panel-text">垃圾信息</div>
            <span> {{ stat.complaints.ads }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as complaints from "@/api/complaints";
export default {
  name: 'dashboard',
  data() {
    return {
      stat:{
        complaints:{},
        xmData:{}
      }
    }
  },
  created(){
    let that = this;
    complaints.getStat().then(res=>{
      that.stat.complaints = res.result;
    });
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .panel-group {
    margin-top: 18px;
    .card-panel-col {
      margin-bottom: 32px;
    }
    .card-panel {
      height: 108px;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);
      &:hover {
        .card-panel-icon-wrapper {
          color: #fff;
        }
        .icon-people {
          background: #40c9c6;
        }
        .icon-message {
          background: #36a3f7;
        }
        .icon-money {
          background: #f4516c;
        }
        .icon-shoppingCard {
          background: #34bfa3
        }
      }
      .icon-people {
        color: #40c9c6;
      }
      .icon-message {
        color: #36a3f7;
      }
      .icon-money {
        color: #f4516c;
      }
      .icon-shoppingCard {
        color: #34bfa3
      }
      .card-panel-icon-wrapper {
        float: left;
        margin: 14px 0 0 14px;
        padding: 16px;
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }
      .card-panel-icon {
        float: left;
        font-size: 48px;
      }
      .card-panel-description {
        width:120px;
        float: right;
        font-weight: bold;
        font-size: 26px;
        margin: 26px;
        margin-left: 0px;
        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 20px;
          margin-bottom: 12px;
        }
        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }

  .dashboard-editor-container {
  padding: 20px;
  background-color: rgb(240, 242, 245);
  min-height: calc(100vh - 84px);

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }

  .component-item {
    min-height: 100px;
  }
  .divider {
    font-size:20px;
    background-color: rgb(240, 242, 245);
  }

  .el-divider__text {
    color:blue;
      font-size:20px;
      background-color: rgb(240, 242, 245);
  }
}

</style>